module.exports = __webpack_public_path__ + "static/windows.d99718f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/windows.png
// module id = 41
// module chunks = 168707334958949